import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import {
  BASE_SITE_CONTEXT_ID,
  ContextServiceMap,
  CURRENCY_CONTEXT_ID,
  CurrencyService,
  LANGUAGE_CONTEXT_ID,
  provideConfig
} from '@spartacus/core'
import { CookieService } from 'ngx-cookie-service'
import { AppRoutingModule } from './app-routing.module'
import { EbComponentsModule } from './components/eb-components.module'
import { EbConfigurationModule } from './configuration/eb-configuration.module'
import { EbAnalyticsService } from './features/analytics/services/facades/eb-analytics.service'
import { ebLayoutConfig } from './features/config/eb-layout.config'
import { CustomCmsComponentsModule } from './features/custom-cms-components/custom-cms-components.module'
import { EbFeaturesModule } from './features/eb-features.module'
import { EbBaseSiteService } from './features/site-context/services/eb-base-site.service'
import { EbCountryService } from './features/site-context/services/eb-country.service'
import { EbLanguageService } from './features/site-context/services/eb-language.service'
import { SpartacusModule } from './spartacus/spartacus.module'

function serviceMapFactory() {
  return {
    [BASE_SITE_CONTEXT_ID]: EbBaseSiteService,
    country: EbCountryService,
    [LANGUAGE_CONTEXT_ID]: EbLanguageService,
    [CURRENCY_CONTEXT_ID]: CurrencyService
  }
}

@NgModule({
  imports: [
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    EbComponentsModule,
    EbConfigurationModule,
    SpartacusModule,
    EbFeaturesModule,
    StoreDevtoolsModule.instrument({
      maxAge: 50,
      connectInZone: true
    }),
    CustomCmsComponentsModule,
    NgbModule
  ],
  providers: [
    {
      provide: ContextServiceMap,
      useFactory: serviceMapFactory
    },
    provideConfig(ebLayoutConfig),
    CookieService,
    EbAnalyticsService.initializeProvider,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
